import classnames from 'classnames/bind'
import format from 'date-fns/format'
import { HTMLAttributes } from 'react'

// Components
import Icon from '@/assets/icons'
import Insight from '../../Insight'

// Constants
import signalData from '@/assets/lotties/signal.json'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

export type VideoStatusType = 'live' | 'today' | 'past' | 'future' | 'myLive' | 'vip'

type VideoStatusTagProps = HTMLAttributes<HTMLDivElement> & {
  roomId: string
  typeMap: Partial<Record<VideoStatusType, boolean>>
  time: string
  // 直播中顯示開始時間
  showStartTime?: boolean
  isPreviewDrawer?: boolean
}

const getVideoStatusTypes = (types: VideoStatusTagProps['typeMap']): VideoStatusType[] => {
  return (
    Object.entries(types)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([_, condition]) => condition)
      .map(([status]) => status as VideoStatusType)
  )
}

const VideoStatusTag = ({ roomId, typeMap, time, showStartTime = false, isPreviewDrawer = false, ...props }: VideoStatusTagProps) => {
  const types = getVideoStatusTypes(typeMap)
  const isLive = types.includes('live')
  const isToday = types.includes('today')
  const isPast = types.includes('past')
  const isFuture = types.includes('future')
  const isMyLive = types.includes('myLive')
  const isVip = types.includes('vip')

  const displayStartTime = (() => {
    if (isMyLive) {
      return format(new Date(time), 'yyyy.MM.dd | HH:mm')
    }
    return isLive ? format(new Date(time), 'HH:mm') : format(new Date(time), 'yyyy.MM.dd | HH:mm')
  })()

  return (
    <div className={cx('video-status-tag', { isLive, isMyLive, isToday, isPast, isPreviewDrawer })} {...props}>
      {!isMyLive && isLive && (
        <Insight
          roomId={roomId}
          handleInsightClick={() => {}}
          theme='gray'
          status='empty'
          className={cx('insight1')}
          isCircle
          customLottieData={signalData}
        />
      )}
      {((isMyLive && !isToday) || (!isMyLive && isFuture)) && !isVip && <Icon.Alarm />}
      {isMyLive && isToday && <Icon.Clock />}
      {isPast && !isVip && <Icon.Video />}
      {isVip && (
        <div className={cx('video-status-tag-block-vip')}>
          <div className={cx('video-status-tag-block-vip-icon')}>
            <Icon.Diamond />
          </div>
          VIP
        </div>
      )}
      {(!isLive || showStartTime) && (
        <p
          className={cx('video-status-tag-time')}
          style={{
            fontSize: '12px',
          }}
        >
          {displayStartTime}
        </p>
      )}
      {!isMyLive && isLive && (
        <p className={cx('video-status-tag-block-live')}>
          <Icon.LiveNowTag />
        </p>
      )}
    </div>
  )
}

export default VideoStatusTag
